import { canBid, canTake } from '../utils/orderPricing';
import { useAuth } from '../contexts/AuthContext';
import { isInvoiceBlocked } from '../components/driver/InvoiceProfileHint';
import { useDriverFeeBlocked } from './useDriverFeeBlocked';

// Hva sjåføren kan gjøre med et åpent oppdrag akkurat nå: godta fastprisen (take), legge bud (bid), og om det
// er sperret (manglende utbetaling/fakturering eller forfalt gebyr). Brukes av det åpnede oppdraget i lista.
export function useOrderActionState(order, existingBid) {
  const { userDoc } = useAuth();
  const { blocked: feeBlocked } = useDriverFeeBlocked();
  const blocked = isInvoiceBlocked(order, userDoc, feeBlocked);
  const take = canTake(order) && !existingBid;
  const bid  = canBid(order);
  return { take, bid, blocked };
}
